import { render, staticRenderFns } from "./PlusToMinusEffectComponent.vue?vue&type=template&id=2c404ed1&scoped=true&"
import script from "./PlusToMinusEffectComponent.vue?vue&type=script&lang=js&"
export * from "./PlusToMinusEffectComponent.vue?vue&type=script&lang=js&"
import style0 from "./PlusToMinusEffectComponent.vue?vue&type=style&index=0&id=2c404ed1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c404ed1",
  null
  
)

export default component.exports